module.exports = __webpack_public_path__ + "static/media/first-display-banner.f2aee14b.png";